import { redirect, createFileRoute } from "@tanstack/react-router";

import AdminLayout from "@/layouts/admin";
import { pb } from "@/lib/pocketbase";
import { ErrorPage } from "@/pages/error";

export const Route = createFileRoute("/admin")({
  component: RouteComponent,
  errorComponent: ErrorPage,
  beforeLoad: () => {
    if (!pb.authStore.isValid) {
      throw redirect({ to: "/login" });
    }
  },
});

function RouteComponent() {
  return <AdminLayout />;
}
